console.log('[TEST] order-hq-admin push to GitHub successful! 🚀');
import('./bootstrap');
